import * as React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { isRequestActive } from "redux-request-loading";
import { Button, Confirm } from "semantic-ui-react";

import { requestCustomerUserSignUpEmail, resetCustomerUserEmail } from "../../../../signUpRequest/actions";
import { ApplicationState } from "../../../../applicationState";
import { REQUEST_CUSTOMER_USER_SIGNUP_EMAIL, RESET_CUSTOMER_USER_EMAIL } from "../../../../signUpRequest/actionTypes";

import { CoreDetailProps } from "../Detail";

import ActivateButton from "./ActivateButton";
import DeactivateButton from "./DeactivateButton";

interface CoreDetailsButtonsStateProps {
    isRequestingEmail: boolean;
    isResettingEmail: boolean;
    isConfirmationModalOpen: boolean;
}

interface CoreDetailsButtonsDispatchProps {
    requestSignUpEmail(customerUserId: string): Promise<void>;
    resetEmail(customerUserId: string): Promise<void>;
}

type Props = CoreDetailProps & CoreDetailsButtonsStateProps & CoreDetailsButtonsDispatchProps;

export class CoreDetailsButtonsUnconnected extends React.Component<Props, any> {

    constructor(props: CoreDetailProps & CoreDetailsButtonsStateProps & CoreDetailsButtonsDispatchProps) {
        super(props);
        this.state = {
            isConfirmationModalOpen: false
        };
        this.requestSignUpEmail = this.requestSignUpEmail.bind(this);
        this.openResetEmailConfirmationModal = this.openResetEmailConfirmationModal.bind(this);
        this.closeResetEmailConfirmationModal = this.closeResetEmailConfirmationModal.bind(this);
        this.resetEmail = this.resetEmail.bind(this);
    }

    public render() {
        const activateOrDeactivateButton = this.props.customerUser.active ? (<DeactivateButton />) : (<ActivateButton />);
        return (
            <>
                {activateOrDeactivateButton}
                <Button
                    icon="mail"
                    content="Send Invite"
                    onClick={this.requestSignUpEmail}
                    loading={this.props.isRequestingEmail}
                    disabled={this.props.isRequestingEmail}
                />
                <Button
                    icon="edit"
                    content="Reset Email"
                    onClick={this.openResetEmailConfirmationModal}
                    loading={this.props.isResettingEmail}
                    disabled={this.props.isResettingEmail}
                />
                <Confirm
                    open={this.state.isConfirmationModalOpen}
                    content={`Are you sure you want to reset email for ${this.props.customerUser.emailAddress}?`}
                    onCancel={this.closeResetEmailConfirmationModal}
                    onConfirm={this.resetEmail}
                />
            </>
        );
    }

    private async requestSignUpEmail() {
        await this.props.requestSignUpEmail(this.props.customerUser.id);
    }

    private openResetEmailConfirmationModal() {
        this.setState({ isConfirmationModalOpen: true });
    }

    private closeResetEmailConfirmationModal() {
        this.setState({ isConfirmationModalOpen: false });
    }

    private async resetEmail() {
        await this.props.resetEmail(this.props.customerUser.id);
        await this.setState({ isConfirmationModalOpen: false });
    }
}

const mapStateToProps = (state: ApplicationState): CoreDetailsButtonsStateProps => ({
    isRequestingEmail: isRequestActive(state, REQUEST_CUSTOMER_USER_SIGNUP_EMAIL),
    isResettingEmail: isRequestActive(state, RESET_CUSTOMER_USER_EMAIL),
    isConfirmationModalOpen: false
});

const mapDispatchToProps = (dispatch: ThunkDispatch<ApplicationState, undefined, Action>): CoreDetailsButtonsDispatchProps => ({
    requestSignUpEmail: (customerUserId: string) => dispatch(requestCustomerUserSignUpEmail(customerUserId)),
    resetEmail: (customerUserId: string) => dispatch(resetCustomerUserEmail(customerUserId))
});

export const CoreDetailsButtons = connect(mapStateToProps, mapDispatchToProps)(CoreDetailsButtonsUnconnected);
